<div class="page-body">
    <div>
      <header
      [breadcrumbPath]="breadcrumb"
      ></header>
      <div class="page-content is-fullpage" >
        <div class="form-content" >

          <h2 class="strong">
            <tra slug="title_password_reset"></tra>
          </h2>
          <div class="form-instruction-major">
            <tra-md slug="txt_pass_reset_instr"></tra-md>
          </div>

          <form [formGroup]="formGroup" (ngSubmit)="submitForm()">

            <div class="field">
              <label class="label">
                <tra slug="create_acct_password_cr_lbl"></tra>
              </label>
              <div class="control">
                <input class="input" type="password" [formControl]="formGroup.controls.password">
              </div>
              <div>
                <button class="button is-small is-fullwidth" (click)="togglePasswordPolicy()">
                  <tra *ngIf="!isPasswordPolicyShowing" slug="btn_view_pass_policy"></tra>
                  <tra *ngIf="isPasswordPolicyShowing" slug="btn_hide_pass_policy"></tra>
                </button>
                <div *ngIf="isPasswordPolicyShowing" class="read-detail">
                  <markdown 
                    class="markdown" 
                    [data]="lang.tra('txt_password_advice_and_policy')" 
                    ngPreserveWhitespaces
                  ></markdown>
                </div>
              </div>
            </div>
  
  
            <div class="field">
              <label class="label">
                <tra slug="create_acct_password_cnf_lbl"></tra>
              </label>
              <div class="control">
                <input class="input" type="password" [formControl]="formGroup.controls.passwordConfirm">
              </div>
            </div>

            <div class="notification is-warning" *ngIf="activeFormError">
              <tra-md [slug]="activeFormError"></tra-md>
            </div>
  
            <div>
              <input  
                type="submit" 
                [disabled]="isFormValidated" 
                class="button is-main is-fullwidth"
                [value]="lang.tra('btn_submit')"
              />
            </div>
          </form>

          <div *ngIf="isFormValidated" style="margin-top:2em;">
            <tra-md slug="txt_pass_reset_instr_post"></tra-md>
            <button 
              (click)="login()"
              class="button is-main is-fullwidth"
            >
              <tra slug="btn_continue"></tra>
            </button>
          </div>
  
        </div>
        
      </div>
    </div>
    <footer [hasLinks]="true"></footer>
  </div>
  